import { ReactNode } from "react"
import {
  Block,
  Checkbox,
  LabelMedium,
  ListItemProps,
  Tooltip,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { DEFAULT_MODAL_Z_INDEX } from "#/shared/constants"

type SendFromAnotherWalletFieldProps = {
  tooltipContent?: ReactNode
  isChecked: boolean
  setIsChecked: (isChecked: boolean) => void
} & Omit<ListItemProps, "children">

type SendFromAnotherWalletTooltipProps = {
  tooltipContent: ReactNode
  children: ReactNode
}
function SendFromAnotherWalletTooltip({
  tooltipContent,
  children,
}: SendFromAnotherWalletTooltipProps) {
  if (!tooltipContent) return children

  return (
    <Tooltip
      content={tooltipContent}
      overrides={{
        Body: {
          style: {
            zIndex: DEFAULT_MODAL_Z_INDEX,
          },
        },
      }}
    >
      <Block>{children}</Block>
    </Tooltip>
  )
}

export default function SendFromAnotherWalletField({
  isChecked,
  setIsChecked,
  state,
  tooltipContent,
}: SendFromAnotherWalletFieldProps) {
  const [, theme] = useStyletron()
  return (
    <Block
      display="flex"
      marginLeft={theme.sizing.scale600}
      marginRight={theme.sizing.scale600}
      marginBottom={theme.sizing.scale900}
      marginTop={theme.sizing.scale750}
    >
      <LabelMedium color={theme.colors.contentPrimary} marginRight="auto">
        Send from another wallet
      </LabelMedium>
      <SendFromAnotherWalletTooltip tooltipContent={tooltipContent}>
        <Checkbox
          disabled={state === "disabled"}
          checkmarkType="toggle"
          checked={isChecked}
          onChange={(event) => setIsChecked(event.target.checked)}
        />
      </SendFromAnotherWalletTooltip>
    </Block>
  )
}
